import {SET_EXPLORE_MIXER_EFFECT} from 'constants/action-types.js';
import {SET_EXPLORE_PERSON_SELECTED} from 'constants/action-types.js';
import {SET_EXPLORE_ALL_SEQUENCES} from 'constants/action-types.js';
import {SET_EXPLORE_EQ_EFFECT} from 'constants/action-types.js';
import {SET_RECORDING_EXPLORE_MIX} from 'constants/action-types.js';
import {SET_WORKS_LOADED} from 'constants/action-types.js';
import {SET_WORK_VOLUME} from 'constants/action-types.js';
import {SET_WORK_TRANSPOSE} from 'constants/action-types.js';
import {SET_EXPLORE_MIX_LOADED} from 'constants/action-types.js';
import {SET_MIX_COLOR_VALUE} from 'constants/action-types.js';
import {SET_MIX_HAS_EDITS} from 'constants/action-types.js';
import {REVERB, PHASER, DELAY} from 'constants/mixer-effects.js';
import {LOW, MID, HIGH} from 'constants/eq-types.js';
import {SET_EXPLORE_OPTION} from 'constants/action-types.js';
import {SET_ANNOTATIONS_VIEW} from 'constants/action-types.js';
import {SET_EXPLORE_TOAST} from 'constants/action-types.js';
import {SET_PROJECT_DRAGGING} from 'constants/action-types.js';
import {SET_EXPLORE_UNPUBLISHED} from 'constants/action-types.js';
import {SET_EXPLORE_WORK} from 'constants/action-types.js';
import {HOME} from 'constants/explore-options.js';

let initialState = {
    exploreOption: HOME,
    exploreWork: undefined,
    toast: undefined,
    unpublished: undefined,
    annotationsView: undefined,
    personSelected: undefined,
    recordingMix: false,
    projectDragging: undefined,
    mixColorValues: {},
    allSequences : [],
    workTransposes: {},
    mixHasEdits: false,
    workVolumes: {},
    mixLoaded: undefined,
    mixerEffects: {
        REVERB: true,
        PHASER: false,
        DELAY: false
    },
    eqEffects: {
        LOW: true,
        MID: true,
        HIGH: true
    },
    worksLoaded: []
};

const exploreReducer = (state = initialState, action) => {
    let newState = {... state};
    switch (action.type) {
    case SET_EXPLORE_MIXER_EFFECT:
        newState.mixerEffects = {... newState.mixerEffects};
        newState.mixerEffects[action.payload.effect] = action.payload.toggle;
        return newState;
    case SET_EXPLORE_EQ_EFFECT:
        newState.eqEffects = {... newState.eqEffects};
        newState.eqEffects[action.payload.type] = action.payload.toggle;
        return newState;
    case SET_MIX_COLOR_VALUE:
        newState.mixColorValues = {... newState.mixColorValues};
        newState.mixColorValues[action.payload.id] = action.payload.value;
        return newState;
    case SET_PROJECT_DRAGGING:
        return {
            ... state,
            projectDragging: action.payload
        };
    case SET_EXPLORE_UNPUBLISHED:
        return {
            ... state,
            unpublished: action.payload
        };
    case SET_EXPLORE_PERSON_SELECTED:
        return {
            ... state,
            personSelected: action.payload
        };
    case SET_EXPLORE_WORK:
        return {
            ... state,
            exploreWork: action.payload
        };
    case SET_EXPLORE_TOAST:
        return {
            ... state,
            toast: action.payload
        };
    case SET_MIX_HAS_EDITS:
        return {
            ... state,
            mixHasEdits: action.payload
        };
    case SET_EXPLORE_ALL_SEQUENCES:
        return {
            ... state,
            allSequences: action.payload
        };
    case SET_RECORDING_EXPLORE_MIX:
        return {
            ... state,
            isRecordingMix: action.payload
        };
    case SET_EXPLORE_OPTION:
        return {
            ... state,
            exploreOption: action.payload
        };
    case SET_EXPLORE_MIX_LOADED:
        return {
            ... state,
            mixLoaded: action.payload
        };
    case SET_WORKS_LOADED:
        return {
            ... state,
            worksLoaded: action.payload
        };
    case SET_WORK_TRANSPOSE:
        let workTransposes = {... state.workTransposes};
        workTransposes[action.payload.sequenceId] =
            action.payload.transpose;
        return {
            ... state,
            workTransposes: workTransposes
        };
    case SET_WORK_VOLUME:
        let workVolumes = {... state.workVolumes};
        workVolumes[action.payload.sequenceId] =
            action.payload.volume;
        return {
            ... state,
            workVolumes
        };
    case SET_ANNOTATIONS_VIEW:
        return {
            ... state,
            annotationsView: action.payload
        };
    default:
        return state;
    }
};

export default exploreReducer;
